import apiClient from "../../core/apiClient";
import { ProducerCommissionCompanyOverride } from "../../interfaces/DTO/commissions/producerCommission";
import { ProductType } from "../../interfaces/DTO/mislaka_xml_models";
import { BaseService } from "../BaseService";

const API_URL = "/producer-commission-overrides";

class ProducerCommissionOverrideService extends BaseService<ProducerCommissionCompanyOverride> {
  constructor() {
    super(API_URL);
  }

  async fetchByUserId(userId: number, productType?: ProductType): Promise<ProducerCommissionCompanyOverride[]> {
    const response = await apiClient.get<ProducerCommissionCompanyOverride[]>(`${API_URL}/by-user`, {
      params: { user_id: userId, product_type: productType },
    });
    return response.data;
  }

  async deleteByHandlerAndPath(userId: number, handlerCode: string, investmentPathCode?: number): Promise<void> {
    await apiClient.delete(`${API_URL}/by-handler-path`, {
      params: {
        user_id: userId,
        handler_code: handlerCode,
        investment_path_code: investmentPathCode || undefined
      }
    });
  }


  // 🆕 מחיקה של כל החרגות של handler ו range_key
  async deleteByHandlerAndRangeKey(userId: number, handlerCode: string, rangeKey?: string): Promise<void> {
    await apiClient.delete(`${API_URL}/by-handler-range`, {
      params: {
        user_id: userId,
        handler_code: handlerCode,
        range_key: rangeKey || undefined
      }
    });
  }
  async bulkReplaceByHandlerRange(
    userId: number,
    handlerCode: string,
    overrides: ProducerCommissionCompanyOverride[],
    rangeKey?: string
  ): Promise<number> {
    const response = await apiClient.post<{ created_count: number }>(`${API_URL}/bulk-replace`, overrides, {
      params: {
        user_id: userId,
        handler_code: handlerCode,
        range_key: rangeKey || undefined
      }
    });
    return response.data.created_count;
  }
 
}

export const producerCommissionOverrideService = new ProducerCommissionOverrideService();